import ComingSoon from "@/components/ComingSoon";

const MyDevicesPage = () => {
  return <ComingSoon featureName="My Devices" description="View and manage your enrolled devices. This feature requires backend End-User Portal APIs." />;
};

export default MyDevicesPage;
